import { useMemo } from 'react';
import { Location, matchRoutes, useLocation } from 'react-router-dom';

import { assertUnreachable } from '../../../util/guards';
import { AppRoutePatterns, routePathObjects } from '../../routes';
import { logger } from '../../util/logger';
import { Page } from '../types';

export const useCurrentPage = (): Page => {
  const location = useLocation();
  return useMemo(() => getCurrentPage(location), [location]);
};

function getCurrentPage(location: Location): Page {
  const matchedRoutes = matchRoutes(routePathObjects, location);

  if (!matchedRoutes) {
    const error = new Error(`Current Router Page is not defined: Location: ${JSON.stringify(location)}`);
    logger.log({
      message: error.message,
      error,
    });

    // return default view
    return Page.Home;
  }

  const [{ route }] = matchedRoutes;

  switch (route.path) {
    case AppRoutePatterns.Home: {
      return Page.Home;
    }
    case AppRoutePatterns.Categories: {
      return Page.Categories;
    }
    case AppRoutePatterns.Chatbot: {
      return Page.Chatbot;
    }
    case AppRoutePatterns.Search: {
      return Page.Search;
    }
    case AppRoutePatterns.CategoryById:
    case AppRoutePatterns.CategoryByUri: {
      return Page.Category;
    }
    case AppRoutePatterns.ArticleById:
    case AppRoutePatterns.ArticleByUri: {
      return Page.Article;
    }
    case AppRoutePatterns.RequestSuccessManagerForm: {
      return Page.RequestSuccessManagerForm;
    }
    default:
      assertUnreachable(route.path);
  }
}
